<template>
  <b-modal
    :id="modalId"
    modal-class="social"
    hide-header
    hide-footer
    centered
    @hide="handleAddSocialLink"
  >
    <!-- visible -->
    <template v-if="showSocial == 'social'">
      <div class="header__socials">
        <span class="ico" @click="$bvModal.hide(modalId)">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
            <path
              d="M28 18H8M8 18L16 10M8 18L16 26"
              stroke="#606770"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <h3>Social</h3>
        <span
          class="ico ico__search"
          @click="showSocial = 'search'"
          v-b-tooltip.hover
          title="Search social"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.85406 19.7087C4.39643 19.7087 0 15.3122 0 9.85437C0 4.39656 4.39643 0 9.85406 0C15.3117 0 19.7081 4.39656 19.7081 9.85437C19.7081 15.3122 15.3117 19.7087 9.85406 19.7087ZM9.85406 1.51606C5.23023 1.51606 1.51601 5.2304 1.51601 9.85437C1.51601 14.4783 5.23023 18.1927 9.85406 18.1927C14.4779 18.1927 18.1921 14.4783 18.1921 9.85437C18.1921 5.2304 14.4779 1.51606 9.85406 1.51606Z"
              fill="black"
              fill-opacity="0.5"
            />
            <path
              d="M17.1932 16.1211L24 22.9282L22.9282 24L16.1213 17.1929L17.1932 16.1211Z"
              fill="black"
              fill-opacity="0.5"
            />
          </svg>
        </span>
      </div>
      <div class="body__socials">
        <b-form-select
          v-model="socialNetwork"
          @change="setAddr(socialNetwork.prefix)"
          value-field="item"
          text-field="name"
          :options="options"
          placeholder="Select Network"
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >-- Please Select Network --</b-form-select-option
            >
          </template>
        </b-form-select>
        <div
          class="group-input mb-4 mt-4"
          v-if="
            socialNetwork &&
              socialNetwork.prefix &&
              socialNetwork.prefix.includes('{profileName}')
          "
        >
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              {{ "Profile Name" }}
            </b-input-group-prepend>
            <b-form-input
              v-model="profileName"
              @change="setProfileName($event)"
              aria-label="Text input with checkbox"
            ></b-form-input>
          </b-input-group>
        </div>
        <div
          class="group-input mb-4 mt-4"
          v-if="
            socialNetwork &&
              socialNetwork.prefix &&
              socialNetwork.prefix.includes('{profileId}')
          "
        >
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              {{ "Profile ID" }}
            </b-input-group-prepend>
            <b-form-input
              v-model="profileId"
              @change="setProfileId($event)"
              aria-label="Text input with checkbox"
            ></b-form-input>
          </b-input-group>
        </div>
        <div class="group-input mt-4" v-if="socialAddr">
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              {{ socialAddr }}
            </b-input-group-prepend>
            <!-- <b-form-input
              v-model="socialAddr"
              aria-label="Text input with checkbox"
            ></b-form-input> -->
          </b-input-group>
        </div>
        <div class="d-flex justify-content-between mt-4">
          <b-button
            style="width: 100%;"
            variant="primary"
            @click="addSocialLink"
          >
            Add
          </b-button>
        </div>
        <div class="social" v-for="(link, n) in links" :key="n">
          <div class="group-input mb-4 mt-4">
            <b-input-group class="mb-2">
              <b-input-group-prepend class="pt-3 pb-3 pl-2">
                {{ makeLink(link) }}
              </b-input-group-prepend>
              <!-- <b-form-input
              :value="link.address"
              aria-label="Text input with checkbox"
              readonly
            ></b-form-input> -->
              <span class="delete"
                ><svg
                  class="delete-svg"
                  @click="removeSocialLink(n)"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.3335 4.00008C1.3335 3.63189 1.63197 3.33341 2.00016 3.33341H14.0002C14.3684 3.33341 14.6668 3.63189 14.6668 4.00008C14.6668 4.36827 14.3684 4.66675 14.0002 4.66675H2.00016C1.63197 4.66675 1.3335 4.36827 1.3335 4.00008Z"
                    fill="#EF5C4A"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.66683 2.00008C6.49002 2.00008 6.32045 2.07032 6.19543 2.19534C6.0704 2.32037 6.00016 2.48994 6.00016 2.66675V3.33341H10.0002V2.66675C10.0002 2.48994 9.92992 2.32037 9.8049 2.19534C9.67988 2.07032 9.51031 2.00008 9.3335 2.00008H6.66683ZM11.3335 3.33341V2.66675C11.3335 2.13631 11.1228 1.62761 10.7477 1.25253C10.3726 0.877462 9.86393 0.666748 9.3335 0.666748H6.66683C6.1364 0.666748 5.62769 0.877462 5.25262 1.25253C4.87754 1.62761 4.66683 2.13631 4.66683 2.66675V3.33341H3.3335C2.96531 3.33341 2.66683 3.63189 2.66683 4.00008V13.3334C2.66683 13.8638 2.87754 14.3726 3.25262 14.7476C3.62769 15.1227 4.1364 15.3334 4.66683 15.3334H11.3335C11.8639 15.3334 12.3726 15.1227 12.7477 14.7476C13.1228 14.3726 13.3335 13.8638 13.3335 13.3334V4.00008C13.3335 3.63189 13.035 3.33341 12.6668 3.33341H11.3335ZM4.00016 4.66675V13.3334C4.00016 13.5102 4.0704 13.6798 4.19543 13.8048C4.32045 13.9298 4.49002 14.0001 4.66683 14.0001H11.3335C11.5103 14.0001 11.6799 13.9298 11.8049 13.8048C11.9299 13.6798 12.0002 13.5102 12.0002 13.3334V4.66675H4.00016Z"
                    fill="#EF5C4A"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.66683 6.66675C7.03502 6.66675 7.3335 6.96522 7.3335 7.33341V11.3334C7.3335 11.7016 7.03502 12.0001 6.66683 12.0001C6.29864 12.0001 6.00016 11.7016 6.00016 11.3334V7.33341C6.00016 6.96522 6.29864 6.66675 6.66683 6.66675Z"
                    fill="#EF5C4A"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.3335 6.66675C9.70169 6.66675 10.0002 6.96522 10.0002 7.33341V11.3334C10.0002 11.7016 9.70169 12.0001 9.3335 12.0001C8.96531 12.0001 8.66683 11.7016 8.66683 11.3334V7.33341C8.66683 6.96522 8.96531 6.66675 9.3335 6.66675Z"
                    fill="#EF5C4A"
                  ></path></svg
              ></span>
            </b-input-group>
          </div>
        </div>
      </div>
    </template>
    <template v-if="showSocial == 'search'">
      <div class="header__socials header__search">
        <input
          type="search"
          class="search"
          v-model="searchStr"
          placeholder="Search"
        />
        <span class="ico" @click="hideSearch">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="14.2222"
                  height="14.2222"
                  fill="white"
                  transform="translate(8.88867 8.88892)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
      </div>
      <div class="body__socials">
        <div class="">
          <div
            class="social"
            v-for="(link, n) in searchedSocial"
            :key="n"
            @click="toogleSocial(link)"
            :class="{ active: links.includes(link.type.toLowerCase()) }"
          >
            <div class="group-input mb-4 mt-4">
              <b-input-group class="mb-2">
                <b-input-group-prepend class="pt-3 pb-3 pl-2">
                  {{ makeLink(link) }}
                </b-input-group-prepend>
                <!-- <b-form-input
              :value="link.address"
              aria-label="Text input with checkbox"
              readonly
            ></b-form-input> -->
                <span class="delete"
                  ><svg
                    class="delete-svg"
                    @click="removeSocialLink(n)"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.3335 4.00008C1.3335 3.63189 1.63197 3.33341 2.00016 3.33341H14.0002C14.3684 3.33341 14.6668 3.63189 14.6668 4.00008C14.6668 4.36827 14.3684 4.66675 14.0002 4.66675H2.00016C1.63197 4.66675 1.3335 4.36827 1.3335 4.00008Z"
                      fill="#EF5C4A"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.66683 2.00008C6.49002 2.00008 6.32045 2.07032 6.19543 2.19534C6.0704 2.32037 6.00016 2.48994 6.00016 2.66675V3.33341H10.0002V2.66675C10.0002 2.48994 9.92992 2.32037 9.8049 2.19534C9.67988 2.07032 9.51031 2.00008 9.3335 2.00008H6.66683ZM11.3335 3.33341V2.66675C11.3335 2.13631 11.1228 1.62761 10.7477 1.25253C10.3726 0.877462 9.86393 0.666748 9.3335 0.666748H6.66683C6.1364 0.666748 5.62769 0.877462 5.25262 1.25253C4.87754 1.62761 4.66683 2.13631 4.66683 2.66675V3.33341H3.3335C2.96531 3.33341 2.66683 3.63189 2.66683 4.00008V13.3334C2.66683 13.8638 2.87754 14.3726 3.25262 14.7476C3.62769 15.1227 4.1364 15.3334 4.66683 15.3334H11.3335C11.8639 15.3334 12.3726 15.1227 12.7477 14.7476C13.1228 14.3726 13.3335 13.8638 13.3335 13.3334V4.00008C13.3335 3.63189 13.035 3.33341 12.6668 3.33341H11.3335ZM4.00016 4.66675V13.3334C4.00016 13.5102 4.0704 13.6798 4.19543 13.8048C4.32045 13.9298 4.49002 14.0001 4.66683 14.0001H11.3335C11.5103 14.0001 11.6799 13.9298 11.8049 13.8048C11.9299 13.6798 12.0002 13.5102 12.0002 13.3334V4.66675H4.00016Z"
                      fill="#EF5C4A"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.66683 6.66675C7.03502 6.66675 7.3335 6.96522 7.3335 7.33341V11.3334C7.3335 11.7016 7.03502 12.0001 6.66683 12.0001C6.29864 12.0001 6.00016 11.7016 6.00016 11.3334V7.33341C6.00016 6.96522 6.29864 6.66675 6.66683 6.66675Z"
                      fill="#EF5C4A"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.3335 6.66675C9.70169 6.66675 10.0002 6.96522 10.0002 7.33341V11.3334C10.0002 11.7016 9.70169 12.0001 9.3335 12.0001C8.96531 12.0001 8.66683 11.7016 8.66683 11.3334V7.33341C8.66683 6.96522 8.96531 6.66675 9.3335 6.66675Z"
                      fill="#EF5C4A"
                    ></path></svg
                ></span>
              </b-input-group>
            </div>
            <!-- <div>
              <div class="left">
                <img :src="getSvg(link.type)" alt="social-image" width="50" />
                <h4>{{ link.type }}</h4>
              </div>
              <div class="ico video">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M12.0002 5.14282V18.8571"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.14282 12.0002L18.8571 12.0002"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div class="ico check">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                  <path
                    d="M4 13.875L8.09091 18L19 7"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
            <p>{{link}}</p> -->
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import socialsMixin from "@/mixins/Socials";
export default {
  mixins: [socialsMixin],
  props: {
    modalId: {
      type: String,
      default: "block-social"
    },
    links: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      maxAmtofsocials: 100,
      showSocial: "social", //social, display, search
      searchStr: "",
      activeDisplaysocial: {},
      socialNetwork: null,
      profileName: "",
      profileId: "",
      socialAddr: ""
    };
  },
  mounted() {},
  watch: {
    showSocial(newv, oldv) {
      if (newv == "search") {
        setTimeout(() => {
          document.querySelector(".search").focus();
        }, 100);
      }
    }
  },
  computed: {
    options() {
      return this.$socials.map(e => {
        return {
          item: { prefix: e.prefix, type: e.type },
          name: e.name
        };
      });
    },
    searchedSocial() {
      if (this.searchStr.trim() == "") return this.links;

      return this.links.filter(link => {
        return link.type
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
      });
    }
  },
  methods: {
    setAddr(addr) {
      this.socialAddr = addr;
    },
    setProfileName(name) {
      let updatedSocialAddr = this.socialAddr.replace(/{profileName}/g, name);
      this.socialAddr = updatedSocialAddr;
    },
    setProfileId(id) {
      let updatedSocialAddr = this.socialAddr.replace(/{profileId}/g, id);
      this.socialAddr = updatedSocialAddr;
    },
    makeLink(link) {
      let prefix = this.getPrefix(link.type);
      let fullLink = prefix
        .replace(/{profileName}/g, link.profileName)
        .replace(/{profileId}/g, link.userId);
      return fullLink;
    },
    getPrefix(type) {
      let social = this.$socials.filter(social => social.type == type);
      return social ? social[0].prefix : "";
    },
    getSvg(type) {
      let social = this.$socials.filter(social => social.type == type);
      return social[0].svg;
    },
    addSocialLink() {
      console.log("social network => ", this.socialNetwork);
      let posIncr = this.links.length == 0 ? 0 : this.links.length + 1;
      let newSocialLink = {
        type: this.socialNetwork.type,
        profileName: this.profileName,
        userId: this.profileId,
        pos: posIncr,
        isAvail: true
      };
      this.links.push(newSocialLink);
      this.reset();
    },
    removeSocialLink(index) {
      this.links.splice(index);
    },
    handleAddSocialLink() {
      this.$emit("handleAddSocialLink", this.links);
    },
    reset() {
      this.socialNetwork = null;
      this.socialAddr = "";
      this.profileName = "";
      this.profileId = "";
    },
    hideSearch() {
      this.searchStr = "";
      this.showSocial = "social";
    },
    toogleSocial(link) {
      this.searchStr = "";
      let linkIndex = this.links.indexOf(link.type.toLowerCase());
      if (linkIndex >= 0) {
        this.links.splice(linkIndex, 1);
        // this.social.splice(socialIndex, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.social {
  .header__socials {
    position: relative;
    padding-bottom: 8px;
    &.border-none::after {
      content: none !important;
    }
    .ico {
      position: absolute;
      top: 5px;
      left: 13px;
      cursor: pointer;
    }
    .ico__search {
      left: unset !important;
      right: 13px;
    }
    h3 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;

      color: #5b606c;
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      border-bottom: 1px solid #e4e6eb;
    }
  }
  .body__socials {
    height: 100%;
    .filter {
      display: flex;
      align-items: center;
      margin-top: 20px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #5b606c;
        width: 160px;
        margin: 0;
      }
      .filters {
        height: 45px;
        display: flex;
        align-items: center;
        max-width: 100%;
        overflow-x: scroll;
        &::-webkit-scrollbar {
          height: 0px;
          margin-right: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background: #dddddd;
          // border-radius: 16px;
        }
        .filter_ {
          cursor: pointer;
          padding: 8px 16px;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          background-color: #fff;
          color: #5b606c;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
          border-radius: 32px;
          margin-right: 16px;
          &.active {
            background: rgba(85, 126, 251, 0.1);
            color: var(--theme-color);
            box-shadow: none;
          }
        }
      }
    }
    .social__wraper {
      padding: 32px 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 24px 12px;
      max-height: 530px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 5px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
      }
    }
    .social {
      cursor: pointer;
      position: relative;
      border-radius: 5px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      .social-event {
        padding: 18px;
        & > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .delete {
        .delete-svg {
          position: absolute;
          right: 0;
          top: 25%;
        }
      }
      .video {
        position: absolute;
        top: 22px;
        right: 18px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #474d52;
        margin-top: 10px;
        margin-bottom: 0;
      }
      h4 {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        margin-bottom: 0;
        margin-left: 10px;
      }
      .left {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .check {
        display: none;
      }
      &.active {
        .check {
          display: block !important;
        }
        .video {
          display: none !important;
        }
        background-color: #e8eaf9;
      }
    }
    .description__wraper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: column;
      img {
        margin-bottom: 34px;
        height: 48px;
        width: 48px;
      }
      h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        color: #5b606c;
        margin-bottom: 34px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;

        color: #5b606c;
      }
      .btn-add-crew {
        margin-top: 80px;
        margin-bottom: 30px;
      }
    }
  }
}
.header__search {
  display: flex;
  align-items: center;
  input {
    border: none;
    padding: 5px 10px;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    //   text-align: center;
    color: #5b606c;
  }
  .ico {
    left: unset !important;
    right: 13px;
  }
}
.social-image {
  width: 50px;
}
@media (max-width: 520px) {
  .body__socials {
    grid-template-columns: 1fr !important;
  }
}
</style>
<style>
#block-social___BV_modal_content_,
#crew-modal___BV_modal_content_ {
  height: 700px;
}
</style>
